import { DatesModel } from "..";
import { datesDictionary } from "..";
import { SportsGroupedByDateResponse, DateRange, SportsGroupedByDate } from "sb-resp-lib";

export interface IGroupedSportsToDatesMapper {
    getDates(response:SportsGroupedByDateResponse, today: Date, timezone: number): DatesModel[]
}

const WeekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const Months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const OneDay =  1 * 24 * 60 * 60000;

export class GroupedSportsToDatesMapper implements IGroupedSportsToDatesMapper
{
    private readonly dict: datesDictionary;

    constructor(dict: datesDictionary)
    {
        this.dict = dict;
    }

    getDates(response: SportsGroupedByDateResponse, today: Date,  timezone: number): DatesModel[] {
        const timezoneShift = (today.getTimezoneOffset() + timezone * 60) * 60000;
        return response.sports ? this.mapToDates(response.sports, timezoneShift, today) : [];
    }

    private mapToDates(sports: SportsGroupedByDate[], timezoneShift: number, today: Date) {
        return sports.reduce(this.groupsReducer, []).map((date, index) => this.getDatesModel(date, index, timezoneShift, today));
    }

    private groupsReducer(accumulator: Date[], current: SportsGroupedByDate) {
        if (current.date && current.sport && current.sport.fixturesCount && current.sport.fixturesCount > 0)
        {
           accumulator.push(new Date(current.date));
        }
        return accumulator;
    }

    private getDatesModel(date: Date, index: number, timezoneShift: number, today: Date) {
        const shiftedDate = this.shiftDate(date, timezoneShift);
        return new DatesModel({
            id: shiftedDate.getDate().toString(),
            from: date,
            timeRange: DateRange.TimeRangeEnum.OneDay,
            order: index,
            dayOfWeek : this.getDayOfWeek(date, today, shiftedDate.getDay()),
            formattedDate: this.getFormattedDate(shiftedDate)
        });
    }

    private getDayOfWeek(date: Date, today: Date, dayNumber: number) {
        const diff = date.getTime() - today.getTime();
        if (!diff)
        {
            return this.dict.Today;
        }
        else if (diff === OneDay)
        {
            return this.dict.Tomorrow;
        }
        else
        {
            return this.dict[WeekDays[dayNumber]];
        }
    }

    private getFormattedDate(date: Date) {
        const day = date.getDate();
        const month = Months[date.getMonth()];
        return `${this.dict[month]} ${day}`
    }

    private shiftDate(day: Date, timezoneShift: number) {
        return new Date(day.getTime() + timezoneShift);
    }
}